import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import type { 
  Company, 
  Industry, 
  CompanyWithNews, 
  IndustryWithNews,
  SelectedCompany,
  SelectedIndustry 
} from '../types';

interface WatchlistState {
  // 数据状态
  watchedCompanies: CompanyWithNews[];
  watchedIndustries: IndustryWithNews[];
  allCompanies: Company[];
  allIndustries: Industry[];
  
  // 选择状态
  selectedCompany: SelectedCompany | null;
  selectedIndustry: SelectedIndustry | null;
  showIndustrySelector: boolean;
  
  // 加载状态
  watchlistInitialized: boolean;
  loading: boolean;
  
  // Actions
  setWatchedCompanies: (companies: CompanyWithNews[]) => void;
  setWatchedIndustries: (industries: IndustryWithNews[]) => void;
  setAllCompanies: (companies: Company[]) => void;
  setAllIndustries: (industries: Industry[]) => void;
  setSelectedCompany: (company: SelectedCompany | null) => void;
  setSelectedIndustry: (industry: SelectedIndustry | null) => void;
  setShowIndustrySelector: (show: boolean) => void;
  setWatchlistInitialized: (initialized: boolean) => void;
  setLoading: (loading: boolean) => void;
  
  // 重置相关状态的复合操作
  resetSelections: () => void;
  resetAll: () => void;
}

export const useWatchlistStore = create<WatchlistState>()(
  subscribeWithSelector((set) => ({
    // Initial state
    watchedCompanies: [],
    watchedIndustries: [],
    allCompanies: [],
    allIndustries: [],
    selectedCompany: null,
    selectedIndustry: null,
    showIndustrySelector: false,
    watchlistInitialized: false,
    loading: false,
    
    // Simple setters
    setWatchedCompanies: (companies) => set({ watchedCompanies: companies }),
    setWatchedIndustries: (industries) => set({ watchedIndustries: industries }),
    setAllCompanies: (companies) => set({ allCompanies: companies }),
    setAllIndustries: (industries) => set({ allIndustries: industries }),
    setSelectedCompany: (company) => set({ selectedCompany: company }),
    setSelectedIndustry: (industry) => set({ selectedIndustry: industry }),
    setShowIndustrySelector: (show) => set({ showIndustrySelector: show }),
    setWatchlistInitialized: (initialized) => set({ watchlistInitialized: initialized }),
    setLoading: (loading) => set({ loading }),
    
    // Compound operations
    resetSelections: () => set({
      selectedCompany: null,
      selectedIndustry: null,
      showIndustrySelector: false,
    }),
    
    resetAll: () => set({
      watchedCompanies: [],
      watchedIndustries: [],
      allCompanies: [],
      allIndustries: [],
      selectedCompany: null,
      selectedIndustry: null,
      showIndustrySelector: false,
      watchlistInitialized: false,
      loading: false,
    }),
  }))
);